/**
 * Customer Portal (UI) - Better Auth browser client.
 */
import { createAuthClient } from 'better-auth/client';

function resolveAuthBaseUrl(): string {
  if (typeof window !== 'undefined' && window.location?.origin) {
    return new URL('/api/auth', window.location.origin).toString();
  }
  return 'http://localhost/api/auth';
}

export const authClient = createAuthClient({
  baseURL: resolveAuthBaseUrl()
});
